import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n);


if(navigator.language!=undefined) browser_lang = navigator.language.replace('-','_');

var browser_lang = navigator.language!=undefined?navigator.language:'zh_TW';
browser_lang = browser_lang.replace('-','_');

if(browser_lang.indexOf('en')>-1 && browser_lang!='en'){
    browser_lang='en'
}else if(browser_lang.indexOf('zh')>-1){
    if(browser_lang!='zh_TW' && browser_lang!='zh_CN') browser_lang='zh_TW'
}else{
    browser_lang='en'
}
var langMessages = {
 zh_TW: require('./lang/zh_TW.json'),
 zh_CN: require('./lang/zh_CN.json'),
 en: require('./lang/en.json')
}

var i18n = new VueI18n({
  locale: browser_lang,
  messages: langMessages
})
export default i18n
